(function () {
  function initStickyHeader() {
    var rootStyle = document.documentElement.style;
    var desktopHeader = document.querySelector('.site-header-desktop--fixed-true');
    var mobileHeader = document.querySelector('#header');
    var externalBanner = null;
    var observedExternalBanner = null;
    var resizeObserver = null;
    var isProductPage = document.querySelector('.site-header-desktop--product') !== null;
    var productMainNav = document.querySelector('.site-header-desktop--product .main-nav__wrapper:not(.sticky_nav)');
    var isRedesignedProductPage = document.querySelector('.pdp-redesign') !== null;
    var productNavStickAt = null;
    var scheduled = false;

    if (!desktopHeader && !mobileHeader) return;

    // Product templates historically disable the fixed header. The redesigned
    // PDP uses a second sticky row, so its mobile header must remain fixed for
    // the two rows to move as one stack.
    if (isRedesignedProductPage && mobileHeader) {
      mobileHeader.classList.add('mobile_nav-fixed--true');
      mobileHeader.classList.remove('mobile_nav-fixed--false');
      document.body.classList.add('mobile_nav-fixed--true');
      document.body.classList.add('pdp-redesign-page');
    }

    function updateHeaderHeight() {
      scheduled = false;

      externalBanner = document.querySelector('#epb_background') || document.querySelector('#epb_container');

      if (resizeObserver && externalBanner && externalBanner !== observedExternalBanner) {
        if (observedExternalBanner) resizeObserver.unobserve(observedExternalBanner);
        resizeObserver.observe(externalBanner);
        observedExternalBanner = externalBanner;
      }

      var isMobile = window.innerWidth <= 798;
      var activeHeader = isMobile
        ? mobileHeader
        : (isProductPage ? productMainNav : desktopHeader);
      var headerHeight = activeHeader ? activeHeader.offsetHeight : 0;
      var bannerHeight = externalBanner && window.getComputedStyle(externalBanner).display !== 'none'
        ? externalBanner.getBoundingClientRect().height
        : 0;
      var navOffset = headerHeight + bannerHeight;
      var isHomepage = document.body.classList.contains('index');

      // The external promo app injects a late-loading margin-top declaration
      // with !important. Apply the mobile offset to the page instead of moving
      // the fixed header and every homepage section down independently.
      if (isMobile && mobileHeader) {
        mobileHeader.style.setProperty('margin-top', '0px', 'important');
      } else if (mobileHeader) {
        mobileHeader.style.removeProperty('margin-top');
      }

      if (isMobile && (isHomepage || isRedesignedProductPage)) {
        document.body.style.setProperty('padding-top', (headerHeight || 60) + 'px', 'important');
      } else {
        document.body.style.removeProperty('padding-top');
      }

      if (isHomepage || isRedesignedProductPage) {
        document.querySelectorAll('.section-wrapper').forEach(function (sectionWrapper) {
          if (isMobile) {
            sectionWrapper.style.setProperty('margin-top', '0px', 'important');
          } else {
            sectionWrapper.style.removeProperty('margin-top');
          }
        });
      }

      document.body.classList.toggle('external-promo-banner-active', bannerHeight > 0);

      if (isProductPage && productMainNav) {
        if (!productMainNav.classList.contains('pdp-main-nav--sticky')) {
          productNavStickAt = productMainNav.getBoundingClientRect().top + window.scrollY - bannerHeight;
        }

        var shouldStickProductNav = !isMobile &&
          productNavStickAt !== null &&
          window.scrollY >= productNavStickAt;
        productMainNav.classList.toggle('pdp-main-nav--sticky', shouldStickProductNav);
      }

      rootStyle.setProperty('--site-header-height', headerHeight + 'px');
      rootStyle.setProperty('--external-banner-height', bannerHeight + 'px');
      rootStyle.setProperty('--nav-offset', (navOffset || 60) + 'px');
    }

    function scheduleUpdate() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateHeaderHeight);
    }

    updateHeaderHeight();
    window.addEventListener('load', scheduleUpdate);
    window.addEventListener('resize', scheduleUpdate);
    window.addEventListener('scroll', scheduleUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(scheduleUpdate);

      if (desktopHeader) resizeObserver.observe(desktopHeader);
      if (mobileHeader) resizeObserver.observe(mobileHeader);
      if (productMainNav) resizeObserver.observe(productMainNav);
    }

    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        var bannerChanged = mutations.some(function (mutation) {
          var changedNodes = Array.prototype.slice.call(mutation.addedNodes)
            .concat(Array.prototype.slice.call(mutation.removedNodes));

          return changedNodes.some(function (node) {
            return node.nodeType === 1 && (
              node.id === 'epb_container' ||
              node.id === 'epb_background' ||
              (node.querySelector && node.querySelector('#epb_container, #epb_background'))
            );
          });
        });

        if (bannerChanged) scheduleUpdate();
      }).observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    scheduleUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyHeader);
  } else {
    initStickyHeader();
  }
})();
